import axios from 'axios';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import PitcherTable from '../../../components/table/PitcherTable';
import { flatObject } from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from '../../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import PitcherTableWrapper from '../../../components/table/PitcherTableWrapper';
import { useTranslation } from 'react-i18next';

function SituationPitcherRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [situationRecord, setSituationRecord] = useState([]);

    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();

    useEffect(() => {
        let {playerId} = profile;

        let situation1 = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestPitchingRecord', recordName: 'selectPitchSituationRecord',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let situation2 = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestPitchingRecord', recordName: 'selectSituationRecord',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        Promise.all([
            situation1, situation2
        ]).then((result) => {
            let newArr = _.map([...result[0]['data']['result'], ...result[1]['data']['result']], (item) => {
                return flatObject(item);
            });

            let groupingData = _.groupBy(newArr, (item) => {
                return item['groupingType'];
            });

            setSituationRecord(groupingData);
            setLoading(true);
        })
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setLoading(false);
        setSeason(value);
    }

    return (
        <>
        <div style={{position:'absolute', top: '-40px', right: '10px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        {
            !loading ?
            <div style={{height: '1000px'}}><DefaultLoader /></div> :
            <>
            <TableWrapper title={t('platoonSplits2')+'-'+season}>
                <PitcherTable data={situationRecord['pitcherType']} column={'pitcherType'} />
            </TableWrapper>
            <PitcherTableWrapper title={t('pitchCount')+'-'+season} column={'count'} profile={profile} season={season}/>
            <PitcherTableWrapper title={t('basesOccupied')+'-'+season} column={'runnerType'} profile={profile} season={season}/>
            {/* <TableWrapper title={'카운트-'+season}>
                <PitcherTable data={situationRecord['count']} column={'count'} />
            </TableWrapper>
            <TableWrapper title={'주자 상황-'+season}>
                <PitcherTable data={situationRecord['runnerType']} column={'runnerType'} />
            </TableWrapper> */}
            <TableWrapper title={t('homeoraway')+'-'+season}>
                <PitcherTable data={situationRecord['homeOrAway']} column={'homeOrAway'} />
            </TableWrapper>
            <TableWrapper title={t('opponent')+'-'+season}>
                <PitcherTable data={situationRecord['oppTeam']} column={'oppTeam'} />
            </TableWrapper>
            <TableWrapper title={t('battingOrderPositions')+'-'+season}>
                <PitcherTable data={situationRecord['battingOrder']} column={'battingOrder'} />
            </TableWrapper>
            <TableWrapper title={t('byMonth')+'-'+season}>
                <PitcherTable data={situationRecord['month']} column={'month'} />
            </TableWrapper>
            </>
        }
        </>
    )
}

export default SituationPitcherRecord;